import {useSetRecoilState} from 'recoil';
import {useMutation} from 'react-query';
import {
  colorBrands,
} from '../state/colors';
import actions from '../api/colors';

const useFetchFilters = () => {
  const setColorBrands = useSetRecoilState(colorBrands);
  return useMutation('fetchFilters', async () => {
    const filters = await actions.fetchFilters();
    setColorBrands(filters?.data?.brands);
    return filters;
  }, {retry: false});
};

export default useFetchFilters;
